export default {
  error: {},
  info: {},
  success: {},
  muted: false,
  videoEnabled: true,
  appRating: 0,
  isRatingSuccess: false,
  feedbackTags: {},
  landingPageLanguage: 'en',
};
